namespace TerminalApp {

    export class OrderShipmentSearchAssistant extends Assistant {

        oss_menu: HTMLElement;
        search_os_input: HTMLInputElement;
        search_keyword_btn: HTMLButtonElement;

        orderShipment_suggestion_container = document.createElement("div");

        resultReturnInfo: SP.ReturnOrderInfo;

        searchId: number;

        callback: (orderInfo: SP.ReturnOrderInfo) => void;
        constructor() {
            super();

            this.searchId = 0;

            this.container.classList.add("assistant");

            this.initialize();

            this.search_os_input = this.oss_menu.querySelector(".search_input");
            this.search_keyword_btn = this.oss_menu.querySelector(".return_search_keyword_button");

            this.search_keyword_btn.addEventListener("click", () => {
                SP.Sounds.Click.play();
                this.searchId++;
                this.search(this.searchId, this.search_os_input.value);
            });

            this.search_os_input.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    SP.Sounds.Click.play();
                    this.searchId++;
                    this.search(this.searchId, this.search_os_input.value);
                }
            });
        }

        initialize() {
            this.oss_menu = document.createElement("div");

            this.oss_menu.innerHTML = `
                <h1 class="terminal-text-align-center">${SP.Localize("sentance_search_order")}</h1>
                <div style="display: flex; align-items: stretch; margin-bottom: 10px;">
                    <input class="search_input form-control searchInput" type="text" placeholder="${SP.Localize("sentance_search_order")}" autocomplete="off" tabIndex="1" />
                    <button class="return_search_keyword_button searchBtn">${SP.Localize("word_search")}</button>
                </div>
            `;

            this.orderShipment_suggestion_container.classList.add("order_suggestion_container");
            this.oss_menu.appendChild(this.orderShipment_suggestion_container);

            this.container.appendChild(this.oss_menu);
        }

        hide() {
            this.oss_menu.style.display = "none";
        }

        open_orderSearchMenu() {
            this.hide();

            this.container.style.display = "block";

            this.oss_menu.style.display = "block";

            this.search_os_input.focus();
        }

        async open(callback: (orderInfo: SP.ReturnOrderInfo) => void) {

            this.callback = callback;
            this.open_orderSearchMenu();
        }

        close() {
            super.close();
            this.clear();
        }

        clear() {
            this.search_os_input.value = "";
            this.orderShipment_suggestion_container.innerHTML = "";
            this.container.style.display = "none";
        }

        async search(searchId: number, keyword: string) {
            if (keyword.trim() == "") {
                return;
            }

            try {
                this.orderShipment_suggestion_container.innerHTML = `
                    <video autoplay muted loop class="positionMiddel">
                        <source src="/terminal/img/loading.webm" type="video/webm" />
                    </video>
                `;

                var data: any = {
                    keyword: keyword,
                };

                let orders = await SP.Data.ReturnShipment.searchOrderShipmentInfos(data);
                if (searchId != this.searchId) {
                    return;
                }


                this.orderShipment_suggestion_container.innerHTML = "";

                for (var i = 0; i < orders.length; i++) {
                    let customerName = "NULL";
                    var customer = await SP.Data.Customer.getCustomerInfo(orders[i].customerId, false);
                    if (customer) {
                        customerName = customer.customerName;
                    }

                    this.addOrder(orders[i], customerName);
                }
            } catch {

            }
        }

        addOrder(order: SP.ReturnOrderInfo, customerName: string) {
            let searchResultContainer = this.orderShipment_suggestion_container.appendChild(document.createElement("div"));
            searchResultContainer.classList.add("search-suggested-order-result-container", "noselect", "terminal-d-flex", "terminal-align-items-center");

            searchResultContainer.innerHTML = `
                <div class="orderSearchResult-icon-container">
                    <i class="fa-light fa-box orderSearchResult-icon"></i>
                </div>
                <div class="orderSearchResult-info-container">
                    <p class="orderSearchResult-referenceNo">${order.referenceNo} - ${customerName}</p>
                    <span class="orderSearchResult-orderNo">${order.orderNo}</span>
                    <span class="orderSearchResult-customerName"></span>
                </div>
                
            `;

            searchResultContainer.addEventListener('click', () => {
                this.resultReturnInfo = order;

                if (this.callback) {
                    this.callback(order);
                }

                this.close();
            });

            return searchResultContainer;
        }

    }

}